import Relay from 'react-relay';

export const ResourceQuery = {
  resource: () => Relay.QL`query { resource(id: $uuid) }`,
};

export const ResourceItemQuery = {
  resource: () => Relay.QL`query { resource(id: $itemUuid) }`
}

export const ViewerQuery = {
  viewer: () => Relay.QL`query { viewer }`,
};

export const UserSetQuery = {
  userSet: () => Relay.QL`query { user_set(id: $id) }`,
};

export const Query = {
  query: () => Relay.QL`query { query }`,
};



// WEBPACK FOOTER //
// ./webapp/queries/index.js